import { GetterTree, MutationTree, ActionTree } from "vuex";
import { SbeApi } from "@/services/api/SbeApi";

class State {
  isSbeBusy: boolean;
  sbeItems: unknown [];
  sbeItem: unknown;
}

// Создаем объект
const sbeApi = new SbeApi();

// Создаем геттеры
const getters = <GetterTree<State, any>>{

  isSbeBusy(state): boolean {
    return state.isSbeBusy;
  },

  getSbeItems(state): unknown[] {
    return state.sbeItems;
  },

  getSbeItem(state): unknown {
    return state.sbeItem;
  }
};

// Создаем мутации
const mutations = <MutationTree<State>>{

  setIsSbeBusy(state, payload: boolean) {
    state.isSbeBusy = payload
  },

  setSbeItems(state, payload: unknown[]) {
    state.sbeItems = payload
  },

  setSbeItem(state, payload: unknown) {
    state.sbeItem = payload
  }
};

// Создаем действия
const actions = <ActionTree<State, any>>{
  
  // Устанавливаем элемент
  setSbeItem({ commit }, data: any) {
    commit('setSbeItem', data);
  },
  
  // Список элементов
  getSbeItems({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsSbeBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};
    const sort:any = data !== undefined && data.sort !== undefined ? data.sort : {};
    const pagination:any = data !== undefined && data.pagination !== undefined ? data.pagination : {};

    return new Promise((resolve, reject) => {

      // Получаем список элементов
      sbeApi.getSbeItems(filter, sort, pagination)
        .then(
          (response:any) => {
            
            let allSbe,fromIdx

            for (const i in response) {

              if (response[i].getSbeId() == 12) {
                commit('setSbeItem', response[i]);
                allSbe = response[i]
                fromIdx = i
                break;
              }
            }
            response.splice(fromIdx,1)
            response.splice(0,0,allSbe)

            commit('setSbeItems', response);
            commit('setIsSbeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsSbeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Получить элемент
  getSbeItem({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsSbeBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};

    return new Promise((resolve, reject) => {

      // Получаем элемент
      sbeApi.getSbeItem(filter)
        .then(
          (response) => {
            commit('setSbeItem', response);
            commit('setIsSbeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsSbeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Создать элемент
  createSbeItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsSbeBusy', true);

    return new Promise((resolve, reject) => {

      // Создаем элемент
      sbeApi.createSbeItem(data)
        .then(
          (response) => {
            commit('setIsSbeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsSbeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Обновить элемент
  updateSbeItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsSbeBusy', true);

    return new Promise((resolve, reject) => {

      // Обновляем элемент
      sbeApi.updateSbeItem(data)
        .then(
          (response) => {
            commit('setIsSbeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsSbeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Удалить элемент
  deleteSbeItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsSbeBusy', true);

    return new Promise((resolve, reject) => {

      // Удаляем элемент
      sbeApi.deleteSbeItem(data)
        .then(
          (response) => {
            commit('setIsSbeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsSbeBusy', false);
            reject(error);
          }
        );
    });
  }
};

// Создаем модуль
const SbeModule = {
  state: new State(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default SbeModule;